// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__Q6Jx4","title":"NotFoundPage_title__DRIpY","subtitle":"NotFoundPage_subtitle__6OKay","backLink":"NotFoundPage_backLink__+aq0L"};